import { render, staticRenderFns } from "./PackageSettings.vue?vue&type=template&id=077b74ed&scoped=true"
import script from "./PackageSettings.vue?vue&type=script&lang=js"
export * from "./PackageSettings.vue?vue&type=script&lang=js"
import style0 from "./PackageSettings.vue?vue&type=style&index=0&id=077b74ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077b74ed",
  null
  
)

export default component.exports